export default __webpack_public_path__ + "static/media/home1.d1930aab.jpg";